<template>
  <div>
    <v-row>
      <v-col cols="12" sm="8" md="6">
        <v-select
          v-model="hashtag"
          :items="hashtags"
          item-text="hashtag"
          item-value="id"
          label="#Hashtag"
          :error-messages="errHash"
        />
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-btn
          color="primary"
          block
          :loading="loading"
          @click="search()"
        >
          Buscar
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="item in posts"
        :key="item.shortcode"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card>
          <v-img :src="item.thumb"></v-img>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error"
              :disabled="item.aproved"
              @click="aprovePost(item.shortcode)"
            >
              <v-icon left>fas fa-check</v-icon>
              Aprobar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      posts: [],
      aprobados: [],
      hashtags: [],
      hashtag: null,
      loading: false,
      next: false,
      cursor: ''
    }
  },
  computed: {
    errHash () {
      const errs = []
      if (!this.$v.hashtag.$dirty) return errs
      !this.$v.hashtag.required && errs.push('Selecciona un #hashtag')
      return errs
    }
  },
  created () {
    this.getHashtags()
  },
  methods: {
    async search () {
      this.$v.hashtag.$touch()
      if (!this.$v.hashtag.$invalid) {
        this.loading = true
        await this.getAprobados()
        await this.getPosts()
        this.loading = false
      }
    },
    async getHashtags () {
      const { data } = await this.$http.hashtags.get('')
      this.hashtags = data
    },
    async aprovePost (shortcode) {
      try {
        const post = this.posts.find(i => i.shortcode === shortcode)
        post.aproved = true
        await this.$http.igposts.post('', { ...post, hashtag: this.hashtag })
      } catch (error) {
        window.alert('😓 Ha ocurrido un error')
      }
    },
    async getAprobados () {
      const { data } = await this.$http.igposts.get(`?hashtag=${this.hashtag}`)
      this.aprobados = data
    },
    async getPosts () {
      try {
        const found = this.hashtags.find(i => i.id === this.hashtag)
        const hashtag = found.hashtag.substr(1).toLowerCase()
        const { data } = await axios.get(`https://www.instagram.com/explore/tags/${hashtag}/?__a=1`)
        const igposts = data.graphql.hashtag.edge_hashtag_to_media.edges.map(i => {
          return {
            thumb: i.node.thumbnail_src,
            shortcode: i.node.shortcode,
            aproved: false
          }
        })
        this.posts = igposts.filter(i => !this.aprobados.find(j => i.shortcode === j.shortcode))
      } catch (error) {
        window.alert('😓 Ha ocurrido un error')
      }
    }
  },
  validations: {
    hashtag: { required }
  }
}
</script>
